import React from 'react';

function Cell(props) {
	return (
		<div onClick={props.onClick} className={`cell ${props.mark}`}></div>
	)
}

export default Cell;